import styled from '@emotion/styled';
import { Button, Modal, tokens, Text } from '@hotjar/hotsauce';
import { useTranslationWithPrefix } from '@hotjar/translations';
import churnHedgingImg from '@hotjar/shared-assets/images/payments/churn-hedging.svg';

export type ChurnHedgingReasons = 'budget-cuts' | 'project-finished' | 'temporary-pause';

export interface Props {
  reason: ChurnHedgingReasons;
  freeMonths: number;
  onSubmit: (freeMonths: number) => void;
  onContinue: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

const S = {
  ModalBody: styled(Modal.Body)`
    padding: 0;
    background-color: ${tokens.BRAND_COLORS.cobalt_100};
  `,
  OfferContainer: styled.div`
    display: flex;
    align-items: center;
    padding: ${tokens.spacer.x3};
    gap: ${tokens.spacer.x8pt5};
  `,
  OfferTextContainer: styled.div`
    display: flex;
    flex-direction: column;
    gap: ${tokens.spacer.x1pt5};
  `,
  OfferImgContainer: styled.div`
    width: 100%;
    flex-shrink: 10;
  `,
};

export function ChurnHedgingModal({
  reason,
  freeMonths,
  onSubmit,
  onCancel,
  onContinue,
  isLoading,
}: Props): JSX.Element {
  const { t } = useTranslationWithPrefix(`billing:churn-hedging`);

  return (
    <Modal
      isOpen
      contentLabel={t('title', { count: freeMonths })}
      size="l"
      onClose={() => onCancel()}
    >
      <Modal.Header title={t(`${reason}.title`)} subtitle={t(`${reason}.subtitle`)} />

      <S.ModalBody>
        <S.OfferContainer>
          <S.OfferTextContainer>
            <Text textType="subtitle1">{t('title', { count: freeMonths })}</Text>
            <Text textType="body2" textColor="text_light">
              {t('text')}
            </Text>
          </S.OfferTextContainer>

          <img src={churnHedgingImg} alt="" />
        </S.OfferContainer>
      </S.ModalBody>

      <Modal.Footer>
        <Button
          kind="ghost"
          onClick={() => {
            onContinue();
          }}
          isDisabled={isLoading}
        >
          {t('continue')}
        </Button>
        <Button
          onClick={() => {
            onSubmit(freeMonths);
          }}
          isLoading={isLoading}
        >
          {t('free-extension', { count: freeMonths })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
